var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"layoutClass":"campaign-scheduler","err":_vm.err}},[_c('b-row',[_c('b-col',{staticClass:"py-4",attrs:{"cols":"12","md":"8","lg":"6","offset-md":"2","offset-lg":"3"}},[_c('schedule-linkedin-card',{staticClass:"my-3",attrs:{"scheduleModalID":"schedule-campaign-content"},scopedSlots:_vm._u([{key:"schedule-posts-modal",fn:function(){return [_c('schedule-posts-modal',{attrs:{"jobIDs":_vm.api && Array.isArray(_vm.api.jobConnections.edges) && _vm.contentType === 'jobs' ? _vm.api.jobConnections.edges.map(function (ref) {
	var entry = ref.entry;

	return entry.id;
}) : undefined,"contentShareIDs":_vm.api && Array.isArray(_vm.api.contentShareConnections.edges) && _vm.contentType === 'content' ? _vm.api.contentShareConnections.edges.map(function (ref) {
	var entry = ref.entry;

	return entry.id;
}) : undefined,"campaignID":_vm.campaignID},on:{"modal-close":function($event){return _vm.closePage()}}})]},proxy:true}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c43967a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/CampaignScheduler.vue
// module id = gHzb
// module chunks = 86